import { font, colors, zindex, ReduceMotion, FadeInAnimation, animationDurationInMS } from '@chegg-ui/theme';
import { IconButton } from '@chegg-ui/button';
import { Link } from '@chegg-ui/link';
import styled, { css } from 'styled-components';
import { styledSpacing } from './root';
export var activeNavItemBorder = function activeNavItemBorder(width, isActive, leftMargin) {
  return css(["&::before{", " display:block;position:absolute;width:", ";margin-left:", ";background-color:", ";content:'';transition:bottom 0.2s;@media (prefers-reduced-motion:reduce){transition:none;}}"], isActive ? css(["height:5px;bottom:-6px;"]) : css(["height:0;bottom:-11px;"]), width, leftMargin, colors.cheggOrange);
};
export var CenterNavLinkItem = styled(Link).withConfig({
  componentId: "okoej0-0"
})(["position:relative;text-decoration:none;color:", ";margin:auto;box-sizing:border-box;font-family:", ";font-weight:", ";font-size:", ";white-space:nowrap;padding:0 0.125rem;", ";&:visited{color:", ";}&:link,&:hover,&:visited,&:active{text-decoration:none;}"], colors.dark, font.family["default"], font.weight.bold, font.size.px16, function (_ref) {
  var hasSubmenu = _ref.hasSubmenu,
      isActive = _ref.isActive;
  return !hasSubmenu && activeNavItemBorder('calc(100% - 0.25rem)', isActive);
}, colors.dark);
export var MenuButton = styled(IconButton).withConfig({
  componentId: "okoej0-1"
})(["padding:0;& > svg{height:", ";min-height:", ";}position:relative;"], styledSpacing.px12, styledSpacing.px12);
export var CenterNavSpanItem = styled.span.withConfig({
  componentId: "okoej0-2"
})(["color:", ";margin:auto;box-sizing:border-box;font-family:", ";font-weight:", ";font-size:", ";white-space:nowrap;padding:0 0.125rem;cursor:pointer;"], colors.dark, font.family["default"], font.weight.bold, font.size.px16);
export var CenterNavList = styled.ul.withConfig({
  componentId: "okoej0-3"
})(["display:flex;list-style:none;margin:0;padding:0;align-items:center;"]);
export var CenterNavListItem = styled.li.withConfig({
  componentId: "okoej0-4"
})(["padding-right:1.875rem;"]);
export var FlyOutMenuContainer = styled.div.withConfig({
  componentId: "okoej0-5"
})(["display:flex;position:relative;", ";"], function (_ref2) {
  var isActive = _ref2.isActive;
  return activeNavItemBorder('calc(100% - 1.25rem)', isActive, '2px');
});
export var FlyOutDropdown = styled.div.withConfig({
  componentId: "okoej0-6"
})(["position:absolute;z-index:", ";visibility:", ";animation:", ";", " white-space:nowrap;padding:", " ", ";font-family:", ";background-color:", ";color:", ";border:1px solid rgb(221,221,221);filter:drop-shadow(0px 1px 7px rgba(0,0,0,0.25));left:calc(100% - ", ");transform:translateX(-50%) translateY(", ");&::before{content:' ';height:0;width:0;position:absolute;border:", " solid transparent;border-bottom-color:rgb(221,221,221);bottom:100%;left:calc(50%);margin-left:-", ";}&::after{content:' ';height:0;width:0;position:absolute;border:calc(", " - 1px) solid transparent;border-bottom-color:", ";bottom:100%;left:calc(50%);margin-left:calc(-", " + 1px);}"], zindex.dropdown, function (_ref3) {
  var isActive = _ref3.isActive;
  return isActive ? 'visible' : 'hidden';
}, FadeInAnimation({
  duration: animationDurationInMS.slow
}), ReduceMotion, styledSpacing.px16, styledSpacing.px32, font.family["default"], colors.white, colors.white, styledSpacing.px8, styledSpacing.px32, styledSpacing.px12, styledSpacing.px12, styledSpacing.px12, colors.white, styledSpacing.px12);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/signed-out-header/dist/esm/styles/desktop.js
// module id = 534
// module chunks = 11